// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__189Q1","topBottomGutter":"Layout_topBottomGutter__Zc-5q"};